"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoint = void 0;
var useWindowSize_1 = require("./useWindowSize");
var breakpoints = {
    xs: 375,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536,
};
var useBreakpoint = function (wait, method) {
    if (wait === void 0) { wait = 500; }
    if (method === void 0) { method = "throttle"; }
    var size = (0, useWindowSize_1.useWindowSize)();
    var viewports = Object.keys(breakpoints).filter(function (key) { return breakpoints[key] <= size.width; });
    return { viewports: viewports, size: size };
};
exports.useBreakpoint = useBreakpoint;
